<template>
  <qx-card-form title="事故定损" v-show="showComponent">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
export default {
  data () {
    return {
      showComponent: false,
      baseForm: {
        isVehicleDamageOptions: [],
        isOtherAccidentOptions: [],
        isGoodsDamageOptions: [],
        isRoadDamageOptions: [],
        isWoundingOptions: [],
        form: [
          {
            label: '本车车损',
            value: 'isVehicleDamage',
            type: 'select',
            disabled: false,
            default: '-1',
            placeholder: '请选择',
            onChange: () => {
              this.isVehicleDamageChange();
            },
          },
          {
            label: '我方损失金额',
            value: 'lossAmt',
            type: 'input',
            hide: true,
            disabled: false,
            onChange: () => {
              const lossAmt = this.$refs.baseForm.getVal('lossAmt').replace(/[^\d\.]/g, '').replace(/^0(\d+)$/, '$1');
              this.$refs.baseForm.setVal('lossAmt', Number(lossAmt).toFixed(2));
            },
          },
          {
            label: '对方车损',
            value: 'isOtherAccident',
            type: 'select',
            disabled: false,
            default: '-1',
            placeholder: '请选择',
            onChange: () => {
              this.isOtherAccidentChange();
            },
          },
          {
            label: '对方车损金额',
            value: 'otherLossAmt',
            type: 'input',
            hide: true,
            disabled: false,
            onChange: () => {
              const otherLossAmt = this.$refs.baseForm.getVal('otherLossAmt').replace(/[^\d\.]/g, '').replace(/^0(\d+)$/, '$1');
              this.$refs.baseForm.setVal('otherLossAmt', Number(otherLossAmt).toFixed(2));
            },
          },
          {
            label: '是否物损',
            value: 'isGoodsDamage',
            type: 'select',
            disabled: false,
            default: '-1',
            placeholder: '请选择',
          },
          {
            label: '道路损',
            value: 'isRoadDamage',
            type: 'select',
            default: '-1',
            disabled: false,
          },
          {
            label: '人伤标志',
            value: 'isWounding',
            type: 'select',
            default: '-1',
            disabled: false,
          },
          {
            label: '定损单图片',
            value: 'vehicleAccidentLossAssessmentFileIds',
            type: 'img',
            accept: 'image/*',
            disabled: false,
            fileSize: 51200000000,
            attr: {
              limit: 5,
            },
            default: [],
          },
        ],
        rules: {
          isVehicleDamage: [
            { required: true, message: '请选择本车车损', trigger: 'blur' },
          ],
          isOtherAccident: [
            { required: true, message: '请选择对方车损', trigger: 'blur' },
          ],
          isGoodsDamage: [
            { required: true, message: '请选择是否物损', trigger: 'blur' },
          ],
          isRoadDamage: [
            { required: true, message: '请选择道路损', trigger: 'blur' },
          ],
          isWounding: [
            { required: true, message: '请选择人伤标志', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (optionList) {
      this.baseForm.isVehicleDamageOptions = optionList;
      this.baseForm.isOtherAccidentOptions = optionList;
      this.baseForm.isGoodsDamageOptions = optionList;
      this.baseForm.isRoadDamageOptions = optionList;
      this.baseForm.isWoundingOptions = optionList;
    },
    // 初始化图片列表数据
    initImgList (initData, imgListFieldName) {
      if (initData[imgListFieldName] && initData[imgListFieldName].length) {
        for (let item of initData[imgListFieldName]) {
          item.id = item.fileId;
          item.url = item.fileUrl;
        }
      }
    },
    initSelect (data, selectFieldName) {
      if (data[selectFieldName] !== undefined) {
        data[selectFieldName] = String(data[selectFieldName]);
      }
    },
    subAndCacheImgList (formData, imgListFieldName) {
      if (formData[imgListFieldName] && formData[imgListFieldName].length) {
        for (let item of formData[imgListFieldName]) {
          item.fileId = item.id;
          item.fileUrl = item.url;
        }
      }
    },
    // 提交/缓存图片列表数据
    subImgList (formData, imgListFieldName, fildIdsName) {
      if (formData[imgListFieldName] && formData[imgListFieldName].length) {
        let picFileIds = [];
        for (let item of formData[imgListFieldName]) {
          item.fileId = item.id;
          item.fileUrl = item.url;
          picFileIds.push(item.fileId);
        }
        formData[fildIdsName] = picFileIds.join();
      }
    },
    isVehicleDamageChange () {
      if (this.$refs.baseForm.getVal('isVehicleDamage') === '1') {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['lossAmt'],
        });

      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['lossAmt'],
        });
        this.$refs.baseForm.setVal('lossAmt', '');
      }
    },
    isOtherAccidentChange () {
      if (this.$refs.baseForm.getVal('isOtherAccident') === '1') {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['otherLossAmt'],
        });

      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['otherLossAmt'],
        });
        this.$refs.baseForm.setVal('otherLossAmt', '');
      }
    },
    // 显示和禁用逻辑
    showAndDisabledLogic (data) {
      this.showComponent = false;
      let formItemDisabled = false;
      // 定损单图片
      let valaListDisabled = false;

      if (data.accidentState > 1) {
        this.showComponent = true;
      }
      if (data.isVehicleDamage === 1) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['lossAmt'],
        });
      }
      if (data.isOtherAccident === 1) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['otherLossAmt'],
        });
      }

      let accidentRegisterState = `${data.accidentState}`;
      if (this.$route.query.accidentRegisterState) {
        accidentRegisterState = `${this.$route.query.accidentRegisterState}`;
      }

      // 重置一下所有选项
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: false,
      });

      switch (accidentRegisterState) {
        case '1':
          // 事故登记
          break;
        case '2':
          this.showComponent = true;
          if (data.busiCode !== undefined && data.busiCode !== '' && data.busiCode !== null && !this.$route.query.accidentRegisterState) {
            // 管理车辆费用只能修改图片
            formItemDisabled = true;
          }
          break;
        case '3':
          this.showComponent = true;
          formItemDisabled = true;
          valaListDisabled = true;
          break;
        case '4':
          this.showComponent = true;
          formItemDisabled = true;
          valaListDisabled = true;
          break;
        default:
          break;
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: formItemDisabled,
        names: ['isVehicleDamage', 'lossAmt', 'isOtherAccident', 'otherLossAmt', 'isGoodsDamage', 'isRoadDamage', 'isWounding'],
      });
      // 控制定损单图片项操作
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: valaListDisabled,
        names: ['vehicleAccidentLossAssessmentFileIds'],
      });
      for (let name in this.baseForm.rules) {
        if (this.baseForm.rules[name]) {
          const rules = this.baseForm.rules[name];
          for (let item of rules) {
            // 如果组件不显示，则需要将必填项改为非必填，否则无法保存提交（因为会校验）
            item.required = this.showComponent;
          }
        }
      }
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        this.subAndCacheImgList(formData, 'vehicleAccidentLossAssessmentFileIds');
      }
      console.log('车辆定损参数', formData);
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        this.subImgList(formData, 'vehicleAccidentLossAssessmentFileIds', 'vehicleAccidentLossAssessmentFileIds');
      }
      // console.log('提交参数', formData);
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      // 这里处理接口或者缓存返回的数据
      this.showAndDisabledLogic(data);
      this.initSelect(data, 'isVehicleDamage');
      this.initSelect(data, 'isOtherAccident');
      this.initSelect(data, 'isGoodsDamage');
      this.initSelect(data, 'isRoadDamage');
      this.initSelect(data, 'isWounding');
      this.initImgList(data, 'vehicleAccidentLossAssessmentFileIds');
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
